import { updateBranchInfo } from "../store/slices/OrderSlice";
import { next } from "../store/slices/PageSlice";
import { useDispatch, useSelector } from "react-redux";

function Branch({data,distance}) {
    
    const dispatch = useDispatch();
    const order = useSelector((state) => state.order)
    
    const convertTo12HourFormat = (time) => {
        const [hours, minutes] = time.split(':');
        const parsedHours = parseInt(hours, 10);
    
        // Determine if it's AM or PM
        const period = parsedHours >= 12 ? 'PM' : 'AM';
    
        // Convert hours to 12-hour format
        const hours12 = parsedHours % 12 || 12;
    
        // Formatted time in 12-hour format
        const formattedTime = `${hours12}:${minutes} ${period}`;
    
        return formattedTime;
      };

      const nextClick = (branch, distance) => {
        
        dispatch(updateBranchInfo({branch:branch, distance:distance}))
        dispatch(next());
      };

      const defaultBanner = `${pluginDirectoryURL}src/frontend/assets/images/sweet-center.png`;
      
    return (
        <>
            <div className="box" onClick={() => nextClick(data, distance)}>
            <div className="box-top">
              <img className="box-image" src={data.banner?'https://app.salesfry.com/'+data.banner:defaultBanner} alt={data.name} />
              <div className="title-flex">
                <h3 className="box-title">{data.name}</h3>
                <p className="user-follow-info">
                  Opening Time: {convertTo12HourFormat(data.opening_time)} to {convertTo12HourFormat(data.closing_time)}
                </p>
                <p className="description">
                  Address: {data.address}
                </p>
                
                {order.orderType == 'delivery' ? (
                    <p className="description">
                        Distance: {distance} Miles away
                    </p>
                ) : ""}
              </div>
            </div>
          </div>
        </>
    )
}

export default Branch;
